/**
 * vuex-typescript のヘルパーメソッドを定義するファイル。
 */
import { getStoreAccessors } from '../../vuex-typescript'
import RootState from '../../state'
import ComponentState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const { read, commit, dispatch } = getStoreAccessors<ComponentState, RootState>('editor/components')

export namespace Mutations {
  export const setComponent = commit(mutations.setComponent, 'setComponent')
  export const deleteComponent = commit(mutations.deleteComponent, 'deleteComponent')
  export const batchUpdate = commit(mutations.batchUpdate, 'batchUpdate')
  export const setGerberaContent = commit(mutations.setGerberaContent, 'setGerberaContent')
  export const setHeaderSectionContent = commit(mutations.setHeaderSectionContent, 'setHeaderSectionContent')
  export const initializeContent = commit(mutations.initializeContent, 'initializeContent')
  export const setAllComponents = commit(mutations.setAllComponents, 'setAllComponents')
  export const markContentSaved = commit(mutations.markContentSaved, 'markContentSaved')
  export const markContentChanged = commit(mutations.markContentChanged, 'markContentChanged')
  export const requestSaveState = commit(mutations.requestSaveState, 'requestSaveState')
  export const pushHistory = commit(mutations.pushHistory, 'pushHistory')
  export const undo = commit(mutations.undo, 'undo')
  export const redo = commit(mutations.redo, 'redo')
  export const clearHistory = commit(mutations.clearHistory, 'clearHistory')
  export const applyBackup = commit(mutations.applyBackup, 'applyBackup')
}

export namespace Actions {
  export const update = dispatch(actions.update, 'update')
  export const remove = dispatch(actions.remove, 'remove')
  export const move = dispatch(actions.move, 'move')
  export const addToArticle = dispatch(actions.addToArticle, 'addToArticle')
  export const updateGerberaContent = dispatch(actions.updateGerberaContent, 'updateGerberaContent')
  export const updateHeaderSectionContent = dispatch(actions.updateHeaderSectionContent, 'updateHeaderSectionContent')
  export const uploadImages = dispatch(actions.uploadImages, 'uploadImages')
  export const createImageData = dispatch(actions.createImageData, 'createImageData')
  export const loadContent = dispatch(actions.loadContent, 'loadContent')
  export const saveContent = dispatch(actions.saveContent, 'saveContent')
  export const requestSaveState = dispatch(actions.requestSaveState, 'requestSaveState')
  export const undo = dispatch(actions.undo, 'undo')
  export const redo = dispatch(actions.redo, 'redo')
  export const saveToBackup = dispatch(actions.saveToBackup, 'saveToBackup')
  export const loadFromBackup = dispatch(actions.loadFromBackup, 'loadFromBackup')
  export const removeBackup = dispatch(actions.removeBackup, 'removeBackup')
  export const getBackedUpId = dispatch(actions.getBackedUpId, 'getBackedUpId')
}

export namespace Getters {
  export const componentFinder = read(getters.componentFinder, 'componentFinder')
  export const containerFinder = read(getters.containerFinder, 'containerFinder')
  export const getImages = read(getters.getImages, 'getImages')
  export const getTexts = read(getters.getTexts, 'getTexts')
  export const article = read(getters.article, 'article')
  export const idGenerator = read(getters.idGenerator, 'idGenerator')
  export const gerberaContent = read(getters.gerberaContent, 'gerberaContent')
  export const headerSectionContent = read(getters.headerSectionContent, 'headerSectionContent')
  export const isContentSaved = read(getters.isContentSaved, 'isContentSaved')
  export const timeStampForSaveState = read(getters.timeStampForSaveState, 'timeStampForSaveState')
  export const embedScripts = read(getters.embedScripts, 'embedScripts')
  export const canUndo = read(getters.canUndo, 'canUndo')
  export const canRedo = read(getters.canRedo, 'canRedo')
}
